import {takeEvery, select, call, put} from 'redux-saga/effects';
import service from '../../services/ocularis/ocularisService';
import {setAviList} from "../recordings/actions";

function* getAvilist() {
    const { token } = yield select(state => state.API);
    try {
        const { data } = yield call(() => service.getAvilist(token));
        
        yield put(setAviList(data.files));
    }
    catch(e) {

    } finally {

    }
}

export default function*() {
    yield takeEvery('getAviList', getAvilist)
}